import React, { useCallback } from 'react';
import type { Portfolio } from 'venn-api';
import type { SearchMenuItem } from '../../search-menu';
import SearchMenuModal from '../../search-menu/SearchMenuModal';
import { useAllocationSearch } from './AllocationSearchContext';
import { AllocationSearchWrapper } from './AllocationSearchWrapper';

interface AllocationSearchInvestmentViewProps {
  nodeRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  strategy: Portfolio;
}

export const AllocationSearchInvestmentView: React.FC<AllocationSearchInvestmentViewProps> = ({
  nodeRef,
  onClose,
  strategy,
}) => {
  const { selectedConstituent, handleSingleSelectFund } = useAllocationSearch();

  const handleSelected = useCallback(
    async (item: SearchMenuItem) => {
      await handleSingleSelectFund(item);
    },
    [handleSingleSelectFund],
  );

  const excludedItems = (strategy.children || [])
    .filter((child) => child.fund)
    .map(({ fund }) => ({
      id: fund!.id,
      type: 'FUND' as const,
    }));

  const title = selectedConstituent ? (
    <>
      Add investment to: <span className="font-normal">{selectedConstituent.name}</span>
    </>
  ) : (
    'Add investment'
  );

  return (
    <AllocationSearchWrapper nodeRef={nodeRef} onClose={onClose} title={title}>
      <div className="flex-1 flex flex-col overflow-hidden [_.qa-search-menu-modal-table]:max-h-[380px] px-[16px]">
        <SearchMenuModal
          onSelected={handleSelected}
          location="allocation-panel"
          investmentsOnly
          autofocus
          defaultMenuIsOpen
          privateAssetSearchMode="PUBLIC_ONLY"
          customPlaceholder="Search for any investment"
          refreshedStyling
          displayResultsAsBlock
          excludedItems={excludedItems}
          hasDropdown={false}
        />
      </div>
    </AllocationSearchWrapper>
  );
};
